export const KeysConfig = {
    accessToken: 'surveybox:actk',
    refreshToken: 'surveybox:rftk',
    tokenAuth: 'surveybox:tk',
    /** prefix สำหรับจำ variant ของ A/B testing แบบ sticky ต่อ 1 experiment — ใช้เป็น `abVariant + experiment_key` เก็บ publish_key ที่ถูกสุ่มได้ */
    abVariant: 'surveybox:ab:'
};